import ArticleBreadCrumb from "./subs/ArticleBreadCrumb";
import ArticleDetails from "./subs/ArticleDetails";

const ArticleDetail = () => {
  return (
    <div className="rbt-overlay-page-wrapper">
      <ArticleBreadCrumb />
      <div className="rbt-blog-details-area rbt-section-gapBottom breadcrumb-style-max-width">
        <div className="blog-content-wrapper rbt-article-content-wrapper">
          <ArticleDetails />
        </div>
      </div>
    </div>
  );
};

export default ArticleDetail;
